import { atom } from 'nanostores';
import { BaseCommand } from './BaseCommand';
import type { CommandActionContext, CommandShortcut } from '~/lib/stores/command/types';

export class ViewCommand extends BaseCommand {
  view: (context: CommandActionContext & { command: ViewCommand }) => React.ReactNode;

  constructor(details: {
    id: string;
    name: string;
    icon: string;
    view: (context: CommandActionContext & { command: ViewCommand }) => React.ReactNode;
  }) {
    super({ id: details.id, name: details.name, icon: details.icon });
    this.view = details.view;
  }

  action({ commandStore, focusPromptInput }: CommandActionContext) {
    commandStore.router.push(this);
    focusPromptInput();
  }

  #$formValues = atom<[string, any][]>([]);

  setFormValues = (values: [string, any][]) => {
    this.#$formValues.set(values);
  };

  getFormValues() {
    return Object.fromEntries(this.#$formValues.get());
  }

  shortcuts: CommandShortcut[] = [
    {
      label: 'Use Command',
      keys: ['Enter'],
      action: (context) => this.action(context),
    } satisfies CommandShortcut,
  ];
}
